import { render, staticRenderFns } from "./QuestionStemManagementAnother.vue?vue&type=template&id=0574a982&scoped=true"
import script from "./QuestionStemManagementAnother.vue?vue&type=script&lang=js"
export * from "./QuestionStemManagementAnother.vue?vue&type=script&lang=js"
import style0 from "./QuestionStemManagementAnother.vue?vue&type=style&index=0&id=0574a982&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0574a982",
  null
  
)

export default component.exports